export default "__VITE_ASSET__CWG1feUB__"